"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var TabStyles_1 = require("../styles/TabStyles");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var Declarative_1 = require("../utils/Declarative");
var DomWidgets_1 = require("./DomWidgets");
var Icons_1 = require("../icons/Icons");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var Localize_1 = require("../../gen-src/Localize");
var getStyles = function () {
    return {
        containerBase: {
            width: TabStyles_1.TabStyles.Sizing.BaseUnit * 5,
            height: TabStyles_1.TabStyles.Sizing.BaseUnit * 5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'auto',
            outline: 'none',
            flexShrink: 0
        },
        imageContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: TabStyles_1.TabStyles.Sizing.BaseUnit * 3,
            height: TabStyles_1.TabStyles.Sizing.BaseUnit * 3,
        },
    };
};
var CloseButtonWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CloseButtonWidget, _super);
    function CloseButtonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.isKeyDown = false;
        _this.handleHover = function (hover) {
            _this.setState({ hover: hover });
        };
        _this.handleFocus = function (focus) {
            _this.setState({ focus: focus });
        };
        _this.handleActive = function (active) {
            _this.setState({ active: active });
        };
        _this.handleKeyDown = function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                _this.isKeyDown = true;
            }
        };
        _this.handleKeyUp = function (e) {
            if (_this.isKeyDown && (e.key === 'Enter' || e.key === ' ')) {
                _this.isKeyDown = false;
                e.preventDefault();
                e.stopPropagation();
                _this.props.requestClose();
            }
        };
        _this.state = { hover: false, active: false, focus: false };
        return _this;
    }
    CloseButtonWidget.prototype.render = function () {
        var _this = this;
        var styles = getStyles();
        var icon;
        var imageContainerStyle;
        if (this.state.hover || this.state.focus || this.state.active) {
            icon = Icons_1.CloseButtonIcon.icon({ active: true });
            imageContainerStyle = tslib_1.__assign({}, styles.imageContainer, { backgroundColor: TabStyles_1.TabStyles.Colors.F3 });
        }
        else {
            icon = Icons_1.CloseButtonIcon.icon();
            imageContainerStyle = styles.imageContainer;
        }
        return (react_1.createElement(InteractiveDom_1.InteractiveDomWrapper, {
            pointerClick: this.props.requestClose,
            handleHover: this.handleHover,
            handleActive: this.handleActive,
            handleFocus: this.handleFocus,
        }, 
        // The reason we have this 'containerBase' block is to give the button a wider tap-target area on mobile but
        // not change how the button appears, specifically when the mouse hovers over it.
        react_1.createElement(DomWidgets_1.Block, {
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'CloseButton'),
            onBlur: function () { return _this.isKeyDown = false; },
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            role: 'button',
            style: styles.containerBase,
            tabIndex: 0,
            title: this.props.tooltip || Localize_1.Messages.close(),
        }, react_1.createElement(DomWidgets_1.Block, {
            style: imageContainerStyle,
        }, react_1.createElement(DomWidgets_1.Img, {
            src: icon,
            draggable: false,
            style: {
                width: Icons_1.CloseButtonIcon.width,
                height: Icons_1.CloseButtonIcon.height,
            }
        })))));
    };
    return CloseButtonWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.CloseButtonWidget = CloseButtonWidget;
//# sourceMappingURL=CloseButtonWidget.js.map